import { render, staticRenderFns } from "./ConsultaView.vue?vue&type=template&id=29a990ce&scoped=true"
import script from "./ConsultaView.vue?vue&type=script&lang=js"
export * from "./ConsultaView.vue?vue&type=script&lang=js"
import style0 from "./ConsultaView.vue?vue&type=style&index=0&id=29a990ce&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a990ce",
  null
  
)

export default component.exports